import { createStackNavigator } from "@react-navigation/stack";
import React from "react";
import OrderReport from "../components/dashboard/orderReport/orderReport";
import StaffReport from "../components/dashboard/staffReport/staffReport";
import CustomerReport from "../components/dashboard/customerReport/customerReport";
import OfferReport from "../components/dashboard/offerReport/offerReport"
import PaymentReport from "../components/dashboard/paymentReport/paymentReport";
import RevenueReport from "../components/dashboard/revenueReport/revenueReport";
import ProductReportScreen from "../components/dashboard/soldProductReport/soldProductReport";
import Dashboard from "../components/dashboard/dashboard";
import TaxReport from "../components/dashboard/taxReport/taxReport";
import { forSlideFromLeftAnimation } from "../shared/hooks/funcions";

export const DashboardStack = () => {

    const DashBoard = createStackNavigator()

    return (
        <DashBoard.Navigator screenOptions={{ headerShown: false, cardStyleInterpolator: forSlideFromLeftAnimation }} initialRouteName="dashboard" >
            <DashBoard.Screen component={Dashboard} name="dashboard" />
            <DashBoard.Screen component={ProductReportScreen} name="ProductReport" />
            <DashBoard.Screen component={TaxReport} name="TaxReport" />
            <DashBoard.Screen component={PaymentReport} name="PaymentReport" />
            <DashBoard.Screen component={RevenueReport} name="RevenueReport" />
            <DashBoard.Screen component={OrderReport} name="OrderReport" />
            <DashBoard.Screen component={StaffReport} name="StaffReport" />
            <DashBoard.Screen component={CustomerReport} name="CustomerReport" />
            <DashBoard.Screen component={OfferReport} name="OfferReport" />
        </DashBoard.Navigator>
    )
}